import {BasePlateFloor} from "./basePlateFloor";
import {MTEFloor} from "./mteFloor";
import {findChildrenByName} from "../../utils/threeUtils";
import {buildingGroup, toggleModeButtons} from "../../main";
import * as SceneManager from "../../sceneManager";
import {clearGroup} from "../../sceneManager";
import {showMessage} from "../../../ui/ui";
import {t} from "../../../i18n";
import {recalculateBuildingParameters} from "../../calculators/buildingParameters/parameterCalculator";
import {generateMeasurements} from "../measurements/measurementGeneration";
import {floorGroupName} from "../../constants/nameConstants";
import {Box3} from "three";

export const floorTypes = {
    basePlate: 1,
    mteElement: 2
};
export let floorType = floorTypes.mteElement;
export let floorIncludeOutside = false;

export function generateFloor() {
    toggleModeButtons();
    let currentFloors = getCurrentFloor();
    if (currentFloors.length === 0) {
        try {
            if (floorType === floorTypes.basePlate) {
                new BasePlateFloor(floorIncludeOutside);
            } else {
                new MTEFloor(floorIncludeOutside);
                recalculateBuildingParameters().then();
            }
            generateMeasurements().then();
        } catch (e) {
            console.error(e);
            showMessage(e.message);
        }
    } else {
        console.error("Boden existiert bereits. Erstellung mehrerer Böden ist nicht möglich.");
        showMessage(t("floor_exists"));
    }
}

export async function regenerateFloor() {
    let currentFloors = getCurrentFloor();

    if (currentFloors.length === 0) {
        return;
    }

    for (let i = 0; i < currentFloors.length; i++) {
        clearGroup(currentFloors[i]);
        currentFloors[i].removeFromParent();
    }

    try {
        if (floorType === floorTypes.basePlate) {
            new BasePlateFloor(floorIncludeOutside);
        } else {
            new MTEFloor(floorIncludeOutside);
        }
        generateMeasurements().then();
        recalculateBuildingParameters().then();
    } catch (e) {
        console.error(e);
        showMessage(e.message);
    }
}

export function deleteFloor(floorGroup) {
    SceneManager.clearGroup(floorGroup);
    floorGroup.removeFromParent();
}

export function setFloorType(type, includeOutside) {
    floorType = parseInt(type);
    floorIncludeOutside = includeOutside;
}

export function getFloorType() {
    let currentFloors = getCurrentFloor();
    if (currentFloors.length === 0) {
        return floorType.toString();
    } else {
        let type = currentFloors[0].userData.floor.type;
        floorType = type;
        return type.toString();
    }
}

export function getFloorIncludeOutside() {
    let currentFloors = getCurrentFloor();
    if (currentFloors.length === 0) {
        return floorIncludeOutside.toString();
    } else {
        let includeOutside = currentFloors[0].userData.floor.includeOutside;
        floorIncludeOutside = includeOutside;
        return includeOutside;
    }
}

function getCurrentFloor() {
    return findChildrenByName(buildingGroup, floorGroupName);
}

export function getFloorArea()
{
    let currentFloor = getCurrentFloor();
    if (currentFloor.length == 0) {
        return 0;
    }

    let floorBox = new Box3().setFromObject(currentFloor[0]);
    let deltaZ = Math.abs(floorBox.max.z - floorBox.min.z);
    let deltaX = Math.abs(floorBox.max.x - floorBox.min.x);

    return deltaZ * deltaX;
}